import {all, fork} from 'redux-saga/effects';
import provideKeycloakTokenToServicesFlow from './sagas/provideKeycloakTokenToServicesFlow';
import provideArcGISTokenToServicesFlow from './sagas/provideArcGISTokenToServicesFlow';
import errorMessageModalFlow from './sagas/errorMessageModalFlow';

const applicationWatcher = function* applicationWatcher() {
    yield all([
        fork(provideKeycloakTokenToServicesFlow),
        fork(provideArcGISTokenToServicesFlow),
        fork(errorMessageModalFlow),
    ]);
};

export default applicationWatcher;
